import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import { Landing } from "./pages/Landing";
import { DemoPage } from "./pages/DemoPage";
import { GradePage } from "./pages/GradePage";
import { HardwarePage } from "./pages/HardwarePage";
import { BetaPage } from "./pages/BetaPage";

// Public marketing site shell: shared Nav + routed pages + Footer. No auth gate
// — every route is open (this is top-of-funnel). Early-beta CTAs route to the
// waitlist form, which sends applications to Slack through a server-side Worker.
export default function App() {
  return (
    <>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/grade" element={<GradePage />} />
        <Route path="/hardware" element={<HardwarePage />} />
        <Route path="/beta" element={<BetaPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </>
  );
}

// Reset scroll on route change so navigating to a demo starts at the top.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
